<!-- 拆箱管理 -->
<template>
    <div class="container">
        <div class="content">
            <Tabs value="name1">
                <TabPane label="拆小箱操作（将产品从小箱内拆出）" name="name1">
                    <Form :model="formData" label-position="right" :label-width="100">
                        <FormItem label="溯源码数据：">
                            <Input class="width_30 mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入要移出箱的产品溯源码 一行一个，支持手工录入和扫码枪扫码录入"></Input>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                                <div slot="content"><p>录入要移出箱的溯源码数据。</p></div>
                            </Tooltip>
                        </FormItem>
                        <div class="footer">
                            <Button class="mr-24" @click="cancelTabs1">取消</Button>
                            <Button class="theme-bg" type="warning" @click="submitTabs1">确定</Button>
                        </div>
                    </Form>
                </TabPane>
                <TabPane label="拆大箱操作（将小箱从大箱内拆出）" name="name2">
                    <Form :model="formData" label-position="right" :label-width="100">
                        <FormItem label="录入小箱码：">
                            <Input class="width_30 mr-24" type="textarea" v-model="small_box_number" :autosize="{minRows: 10}" placeholder="录入要移出大箱的小箱码 一行一个，支持手工录入和扫码枪扫码录入"></Input>
                            <Tooltip max-width="250" placement="right" theme="light">
                                <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                                <div slot="content"><p>支持手动和扫码枪扫码录入。</p></div>
                            </Tooltip>
                        </FormItem>
                        <div class="footer">
                            <Button class="mr-24" @click="cancelTabs2">取消</Button>
                            <Button class="theme-bg" type="warning" @click="submitTabs2">确定</Button>
                        </div>
                    </Form>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

<script>
import { 
    packing_unpack,
} from '@/api/index';
export default {
    data() {
        return {
            qrcode_number: "",
            small_box_number: "",
            formData: { 
                qrcode_number: [],
                small_box_number: [],
            },
        };
    },
    mounted() {
    },
    methods: {
        // 确定
        submitTabs1(){
            if(this.qrcode_number){
                this.formData.qrcode_number = this.qrcode_number.split('\n').map((item, index) => {
                    if (item === '') {
                        // 如果是空字符串，表示这里有一个换行
                        return null;
                    }
                    return item;
                });
            }
            this.formData.qrcode_number = this.formData.qrcode_number.filter(item => item != null);
            packing_unpack({qrcode_number: this.formData.qrcode_number}).then( res => {
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        submitTabs2(){
            if(this.small_box_number){
                this.formData.small_box_number = this.small_box_number.split('\n').map((item, index) => {
                    if (item === '') {
                        // 如果是空字符串，表示这里有一个换行
                        return null;
                    }
                    return item;
                });
            }
            this.formData.small_box_number = this.formData.small_box_number.filter(item => item != null);
            packing_unpack({small_box_number: this.formData.small_box_number}).then( res => {
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelTabs1(){
            this.qrcode_number = "";
            this.formData.qrcode_number = [];
        },
        cancelTabs2(){
            this.small_box_number = "";
            this.formData.small_box_number = [];
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.footer {
    margin: 12px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
::v-deep .ivu-tabs-tab {
    font-size: 16px;
}
::v-deep .ivu-tabs-nav .ivu-tabs-tab-active {
    color: #FF761D;
    font-size: 16px;
}
::v-deep .ivu-tabs-ink-bar {
    background-color: #FF761D !important;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_30 {
    width: 30vw;
}
</style>